import { useMemo } from 'react';

import { OrderStatusType } from 'api/types/entity/order/orderStatusType';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import {
  ChangeStatusFormSchemaProps,
  useFormContext,
  Field,
} from 'modules/order/order/forms/changeStatusForm';

interface Props extends ChangeStatusFormSchemaProps {}

export const FormContent = ({ availableStatusesMap }: Props) => {
  const { t } = useTranslation();
  const { values } = useFormContext();

  const { isRequiredClosedDate, isRequiredFmNumber, isRequiredReason } =
    useMemo(() => {
      const status = values.status?.value;
      return (
        availableStatusesMap[status] || {
          isRequiredReason: false,
          isRequiredFmNumber: false,
          isRequiredClosedDate: false,
        }
      );
    }, [values.status, availableStatusesMap]);

  const availableStatuses = useMemo(
    () => Object.keys(availableStatusesMap) as OrderStatusType[],
    [availableStatusesMap]
  );

  return (
    <Stack spacing={12}>
      <Field.Autocomplete
        showRequiredMark
        label={t('order.order.dialogStatusChange.fields.status.label')}
        name="status"
        optionLabelKey="label"
        options={availableStatuses.map((status) => ({
          label: t(`order.status.${status}`),
          value: status,
        }))}
        optionValueKey="value"
        placeholder={t(
          'order.order.dialogStatusChange.fields.status.placeholder'
        )}
      />
      {isRequiredReason && (
        <Field.Text
          showRequiredMark
          label={t('order.order.dialogStatusChange.fields.reason.label')}
          name="reason"
          placeholder={t(
            'order.order.dialogStatusChange.fields.reason.placeholder'
          )}
        />
      )}
      {isRequiredClosedDate && (
        <Field.DatePicker
          disableFuture
          showRequiredMark
          label={t('order.order.dialogStatusChange.fields.closedDate.label')}
          name="closedDate"
          placeholder={t(
            'order.order.dialogStatusChange.fields.closedDate.placeholder'
          )}
        />
      )}
      {isRequiredFmNumber && (
        <Field.Number
          showRequiredMark
          label={t('order.order.dialogStatusChange.fields.fmNumber.label')}
          name="fmNumber"
          placeholder={t(
            'order.order.dialogStatusChange.fields.fmNumber.placeholder'
          )}
        />
      )}
    </Stack>
  );
};
